
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"8","y":"8","width":"24","height":"24"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.73 10.616L29.384 8.27 20 17.654 10.615 8.27 8.27 10.616 17.654 20l-9.385 9.384 2.346 2.346L20 22.346l9.384 9.384 2.346-2.346L22.346 20l9.384-9.384z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#1154FA","d":"M0 0h40.218v40.218H0z"}})])])
          )
        }
      }
    